import { type FC, useCallback } from 'react';
import { useSportSidebarBehavior, useTypedDispatch } from '@/hooks';
import { setShowTabletSportSidebar } from '@/store';
import { SportCategoryList } from './components/SportCategoryList/SportCategoryList';
import { SportList } from './components/SportList/SportList';
import type { SportSidebarProps } from './SportSidebar.types';
import styles from './SportSidebar.module.scss';
export const SportSidebar: FC<SportSidebarProps> = ({
  className
}) => {
  const dispatch = useTypedDispatch();
  const {
    sidebarIsOpened,
    isTabletScreen
  } = useSportSidebarBehavior();
  const handleCloseSidebar = useCallback(() => {
    dispatch(setShowTabletSportSidebar(false));
  }, [dispatch]);
  return <aside className={cn(styles.root, className, {
    [styles.isOpened]: sidebarIsOpened
  })} data-sentry-component="SportSidebar" data-sentry-source-file="SportSidebar.tsx">
      <SportList data-sentry-element="SportList" data-sentry-source-file="SportSidebar.tsx" />
      <SportCategoryList data-sentry-element="SportCategoryList" data-sentry-source-file="SportSidebar.tsx" />
      {isTabletScreen && <div className={cn(styles.overlay, {
      [styles.visible]: sidebarIsOpened
    })} role="presentation" onClick={handleCloseSidebar} />}
    </aside>;
};